"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualConnectionDownstreamOwnersPane = void 0;
const tslib_1 = require("tslib");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
const OwnersGridSortProvider_1 = require("../sorting/sortProviders/OwnersGridSortProvider");
const MultiSelectionControls_1 = require("../widgets/MultiSelectionControls");
const VirtualConnectionDownstreamOwnersQueryGrid_1 = require("./VirtualConnectionDownstreamOwnersQueryGrid");
class VirtualConnectionDownstreamOwnersPane extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.fetchAllOwnerKeys = (client) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const sliceable = this.createOwnerIdsSliceable(client);
            const items = yield (0, data_catalog_shared_1.getAllFromSliceable)(sliceable);
            return items.map(item => item.vizportalId);
        });
    }
    render() {
        return (react_1.default.createElement(data_catalog_shared_1.MultiSelectionProvider, { selectionId: this.props.vizportalUrlId }, ({ selectedKeys, setSelectedKeys, updateSelectionForKey }) => (react_1.default.createElement(vizportalclient_common_components_1.VerticalFlexContainer, { fillFlexParent: true },
            react_1.default.createElement(data_catalog_shared_1.PaneTitle, null,
                react_1.default.createElement(vizportalclient_common_components_1.HorizontalFlexContainer, null,
                    this.props.title,
                    this.props.rowCount != null && this.props.rowCount > 0
                        ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(MultiSelectionControls_1.MultiSelectionControls, { selectedKeys: selectedKeys, setSelectedKeys: setSelectedKeys, updateSelectionForKey: updateSelectionForKey, fetchAllKeys: this.fetchAllOwnerKeys }),
                            react_1.default.createElement(data_catalog_shared_1.ComposeEmailPaneButton, { selectedUserIds: selectedKeys, contentType: 'virtualConnection', contentId: this.props.vizportalUrlId, contentLuid: this.props.virtualConnectionLuid })))
                        : null)),
            react_1.default.createElement(OwnersGridSortProvider_1.OwnersGridSortProvider, null, ({ orderBy, updateSortOrder }) => (react_1.default.createElement(VirtualConnectionDownstreamOwnersQueryGrid_1.VirtualConnectionDownstreamOwnersQueryGrid, { vizportalUrlId: this.props.vizportalUrlId, selectedKeys: selectedKeys, updateSelectionForKey: updateSelectionForKey, filteredTableId: this.props.filteredTableId, rowCount: this.props.rowCount, orderBy: orderBy, updateSortOrder: updateSortOrder })))))));
    }
    createOwnerIdsSliceable(client) {
        if (this.props.filteredTableId) {
            return new data_catalog_shared_1.GraphQLSliceable({
                queryGql: catalog_queries_1.DownstreamOwnerIdsFilteredByFieldDocument,
                selectConnectionListResult: (resultData) => {
                    const field = resultData.fields && resultData.fields[0];
                    return field.downstreamOwnersConnection;
                },
                mapResultNode: (node) => node,
            }, { fieldId: this.props.filteredTableId }, client);
        }
        else {
            return new data_catalog_shared_1.GraphQLSliceable({
                queryGql: catalog_queries_1.VirtualConnectionDownstreamOwnerIdsDocument,
                selectConnectionListResult: (resultData) => {
                    const virtualConnection = resultData.virtualConnections && resultData.virtualConnections[0];
                    return virtualConnection.downstreamOwnersConnection;
                },
                mapResultNode: (node) => node,
            }, { vizportalUrlId: this.props.vizportalUrlId }, client);
        }
    }
}
exports.VirtualConnectionDownstreamOwnersPane = VirtualConnectionDownstreamOwnersPane;
//# sourceMappingURL=VirtualConnectionDownstreamOwnersPane.js.map